import React from 'react';
import { Share } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ShareComponent = (props) => {
  return (
    <Share {...props} />
  );
};

export default ShareComponent;
